import { zodResolver } from '@hookform/resolvers/zod';
import { type Account } from '@qdrant/qdrant-cloud-public-api/account/v1';
import { memo, type ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { updateAccountSchema } from '@/components/Settings/helpers';

export const EditAccountDetailsForm = memo(function EditAccountDetailsForm({
  children,
  account,
}: {
  children: NonNullable<ReactNode>;
  account?: Pick<Account, 'name' | 'company'>;
}) {
  const { name, company } = account ?? {};
  const formMethods = useForm({
    mode: 'onTouched',
    values: { name: name ?? '', company },
    resolver: zodResolver(updateAccountSchema),
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
});
